// src/utils/useCommercialAdmin.js
//
// Login + ROLE_ADMIN check for the ambassador admin pages (territories,
// prospects, visit review, settings). The backend checks ROLE_ADMIN on
// every call anyway; this only avoids showing an empty page.
import useRoleAuth from './useRoleAuth';

const ADMIN = ['ROLE_ADMIN'];

export default function useCommercialAdmin() {
  return useRoleAuth(ADMIN);
}
